<!--
    描述：用户详细信息页面
    时间：2021-11-19
    Created by 王帅
-->
<template>
	<div class="wrap-container">
		<el-collapse class="collapse-layout"
					 v-model="activeNames"
					 @change="handleChange">
			<el-collapse-item v-for="(item, index) in infoList"
							  :key="'info' + index"
							  :title="`#${index + 1} ${item.title}`"
							  :name="item.name">
				<!-- 基本信息 -->
				<template v-if="item.name === 'baseInfo'">
					<el-form ref="baseForm"
							 :model="baseForm"
							 :rules="baseRules"
							 size="small"
							 :show-message="false"
							 label-width="120px">
						<el-row>
							<el-col :span="12">
								<el-form-item label="姓名："
											  prop="sname">
									<template v-if="curMode !== 'view'">
										<el-input v-model="baseForm.sname"></el-input>
									</template>
									<template v-else>{{ baseForm.sname }}</template>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="用户名："
											  prop="username">
									<template v-if="curMode !== 'view'">
										<el-input v-model="baseForm.username"></el-input>
									</template>
									<template v-else>{{ baseForm.sname }}</template>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="12">
								<el-form-item label="手机号："
											  prop="phone">
									<template v-if="curMode !== 'view'">
										<el-input v-model="baseForm.phone"></el-input>
									</template>
									<template v-else>{{ baseForm.phone }}</template>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="身份证号码："
											  prop="idCard">
									<template v-if="curMode !== 'view'">
										<el-input v-model="baseForm.idCard"></el-input>
									</template>
									<template v-else>{{ baseForm.idCard }}</template>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="12">
								<el-form-item label="性别："
											  prop="sex">
									<template v-if="curMode !== 'view'">
										<el-radio-group disabled
														v-model="baseForm.sex">
											<el-radio :label="1">男</el-radio>
											<el-radio :label="0">女</el-radio>
										</el-radio-group>
									</template>
									<template v-else>{{
                                        baseForm.sex === '' ? '' : (baseForm.sex === 1 ? "男" : "女")
                                    }}</template>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="民族："
											  prop="nation">
									<template v-if="curMode !== 'view'">
										<el-select v-model="baseForm.nation">
											<el-option v-for="(m, n) in mz"
													   :key="'民族' + n"
													   :label="m.sname"
													   :value="m.value">
											</el-option>
										</el-select>
									</template>
									<template v-else>{{ baseForm.nationName }}</template>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="12">
								<el-form-item label="出生日期："
											  prop="birthDate">
									<template v-if="curMode !== 'view'">
										<el-date-picker v-model="baseForm.birthDate"
														type="date"
														disabled
														format="yyyy-MM-dd"
														value-format="yyyy-MM-dd"
														placeholder="选择日期">
										</el-date-picker>
									</template>
									<template v-else>{{ baseForm.birthDate }}</template>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="年龄："
											  prop="age">
									<template v-if="curMode !== 'view'">
										<el-input disabled
												  v-model="baseForm.age"></el-input>
									</template>
									<template v-else>{{ baseForm.age }}</template>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="12"
									v-if="userInfo.roleType !== 1">
								<!-- <el-col :span="12"> -->
								<el-form-item label="角色："
											  prop="roleIds">
									<template v-if="curMode !== 'view'">
										<el-select v-model="baseForm.roleIds"
												   multiple
												   @remove-tag="onRemoveTag"
												   placeholder="请选择">
											<el-option v-for="(item, index) in roleTreeData"
													   :key="'角色' + index"
													   :disabled="item.disabled"
													   :label="item.label"
													   :value="item.id">
											</el-option>
										</el-select>
									</template>
									<template v-else>{{ baseForm.roleIdNames }}</template>
								</el-form-item>
							</el-col>
							<!-- <el-col :span="12">
                                <el-form-item label="账户状态" prop="orEnable">
                                    <vxe-switch
                                        v-model="baseForm.orEnable"
                                        :disabled="isDisabled"
                                        open-label="启用"
                                        :open-value="1"
                                        close-label="禁用"
                                        :close-value="0"
                                    ></vxe-switch>
                                </el-form-item>
                            </el-col> -->
						</el-row>
					</el-form>
				</template>

				<!-- 工作经验 -->
				<template v-if="item.name === 'companyInfo'">
					<el-row class="pane-list-container"
							v-for="(companyInfoForm, inx) in companyInfoList"
							:key="'companyInfoList' + inx">

						<el-col :span="24"
								class="flex">
							<div class="pane-list-item">
								<el-form ref="companyInfoForm"
										 :model="companyInfoForm"
										 size="small"
										 :show-message="false"
										 label-width="120px">
									<el-col :span="24">
										<el-form-item label="时间："
													  prop="dateRange">
											<template v-if="editMode">
												<el-date-picker v-model="companyInfoForm.dateRange"
																type="daterange"
																range-separator="到"
																format="yyyy-MM-dd"
																:disabled="isDisabled"
																value-format="yyyy-MM-dd"
																start-placeholder="开始日期"
																end-placeholder="结束日期"></el-date-picker>
											</template>
											<template v-else>
												<span v-if="companyInfoForm.startDate">
													{{ companyInfoForm.startDate.substr(0, 11) }}
													<span class="ml10 mr10">到</span>
													{{ companyInfoForm.endDate.substr(0, 11) }}
												</span>
											</template>
										</el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item label="公司："
													  prop="company">
											<template v-if="editMode">
												<el-input v-model="companyInfoForm.company"
														  :disabled="isDisabled"
														  placeholder="请输入公司名称"></el-input>
											</template>
											<template v-else>{{ companyInfoForm.company }}</template>
										</el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item label="公司性质："
													  prop="type">
											<template v-if="editMode">
												<el-select v-model="companyInfoForm.type"
														   :disabled="isDisabled"
														   placeholder="请选择公司性质">
													<el-option v-for="(m, n) in dwxz"
															   :key="'公司性质' + n"
															   :label="m.sname"
															   :value="m.value"></el-option>
												</el-select>
											</template>
											<template v-else>{{ companyInfoForm.typeName }}</template>
										</el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item label="职能："
													  prop="functions">
											<template v-if="editMode">
												<el-input v-model="companyInfoForm.functions"
														  :disabled="isDisabled"
														  placeholder="请输入职能"></el-input>
											</template>
											<template v-else>{{ companyInfoForm.functions }}</template>
										</el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item label="行业："
													  prop="industry">
											<template v-if="editMode">
												<el-input v-model="companyInfoForm.industry"
														  :disabled="isDisabled"
														  placeholder="请输入行业"></el-input>
											</template>
											<template v-else>{{ companyInfoForm.industry }}</template>
										</el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item label="职位："
													  prop="postion">
											<template v-if="editMode">
												<el-input v-model="companyInfoForm.postion"
														  :disabled="isDisabled"
														  placeholder="请输入职位"></el-input>
											</template>
											<template v-else>{{ companyInfoForm.postion }}</template>
										</el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item label="岗位："
													  prop="post">
											<template v-if="editMode">
												<el-input v-model="companyInfoForm.post"
														  :disabled="isDisabled"
														  placeholder="请输入岗位"></el-input>
											</template>
											<template v-else>{{ companyInfoForm.post }}</template>
										</el-form-item>
									</el-col>
									<el-col :span="24">
										<el-form-item label="工作描述："
													  prop="description">
											<template v-if="editMode">
												<el-input v-model="companyInfoForm.description"
														  :disabled="isDisabled"
														  type="textarea"
														  :autosize="{ minRows: 2 }"
														  maxlength="1000"
														  show-word-limit></el-input>
											</template>
											<template v-else>{{ companyInfoForm.description }}</template>
										</el-form-item>
									</el-col>
									<el-col :span="24">
										<el-form-item label="工作类型："
													  prop="jobType">
											<template v-if="editMode">
												<el-radio-group v-model="companyInfoForm.jobType">
													<el-radio-button :label="0"
																	 :disabled="isDisabled">兼职</el-radio-button>
													<el-radio-button :label="1"
																	 :disabled="isDisabled">全职</el-radio-button>
												</el-radio-group>
											</template>
											<template v-else>{{ companyInfoForm.jobType ? '全职' : '兼职' }}</template>
										</el-form-item>
									</el-col>
								</el-form>
							</div>
							<div class="pane-list-btn"
								 v-if="editMode">
								<el-button size="small"
										   type="primary"
										   class="mb10"
										   icon="el-icon-plus"
										   @click="addItem(inx, 'work')"></el-button>
								<el-button size="small"
										   type="danger"
										   icon="el-icon-minus"
										   @click="removeItem(companyInfoForm, inx, 'work')"
										   v-if="inx !== 0"></el-button>
							</div>
						</el-col>
					</el-row>
				</template>

				<!-- 项目经验 -->
				<template v-if="item.name === 'projectInfo'">
					<el-row class="pane-list-container"
							v-for="(projectInfoForm, inx) in projectInfoList"
							:key="'projectInfoList' + inx">
						<el-col :span="24"
								class="flex">
							<div class="pane-list-item">
								<el-form ref="projectInfoForm"
										 :model="projectInfoForm"
										 size="small"
										 :show-message="false"
										 label-width="120px">
									<el-col :span="24">
										<el-form-item label="公司："
													  prop="company">
											<template v-if="editMode">
												<el-input v-model="projectInfoForm.company"
														  :disabled="isDisabled"
														  placeholder="请输入公司名称"></el-input>
											</template>
											<template v-else>{{ projectInfoForm.company }}</template>
										</el-form-item>
									</el-col>
									<el-col :span="24">
										<el-form-item label="时间："
													  prop="dateRange">
											<template v-if="editMode">
												<el-date-picker v-model="projectInfoForm.dateRange"
																:disabled="isDisabled"
																type="daterange"
																range-separator="到"
																format="yyyy-MM-dd"
																value-format="yyyy-MM-dd"
																start-placeholder="开始日期"
																end-placeholder="结束日期"></el-date-picker>
											</template>
											<template v-else>
												<span v-if="projectInfoForm.startTime">
													{{ projectInfoForm.startTime.substr(0, 11) }}
													<span class="ml10 mr10">到</span>
													{{ projectInfoForm.endTime.substr(0, 11) }}
												</span>
											</template>
										</el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item label="项目名称："
													  prop="proName">
											<template v-if="editMode">
												<el-input v-model="projectInfoForm.proName"
														  :disabled="isDisabled"
														  placeholder="请输入项目名称"></el-input>
											</template>
											<template v-else>{{ projectInfoForm.proName }}</template>
										</el-form-item>
									</el-col>
									<el-col :span="24">
										<el-form-item label="项目描述："
													  prop="proDes">
											<template v-if="editMode">
												<el-input v-model="projectInfoForm.proDes"
														  :disabled="isDisabled"
														  type="textarea"
														  :autosize="{ minRows: 2 }"
														  maxlength="1000"
														  show-word-limit></el-input>
											</template>
											<template v-else>{{ projectInfoForm.proDes }}</template>
										</el-form-item>
									</el-col>
									<el-col :span="24">
										<el-form-item label="责任描述："
													  prop="dutyDes">
											<template v-if="editMode">
												<el-input v-model="projectInfoForm.dutyDes"
														  :disabled="isDisabled"
														  type="textarea"
														  :autosize="{ minRows: 2 }"
														  maxlength="1000"
														  show-word-limit></el-input>
											</template>
											<template v-else>{{ projectInfoForm.dutyDes }}</template>
										</el-form-item>
									</el-col>
								</el-form>
							</div>
							<div class="pane-list-btn"
								 v-if="editMode">
								<el-button size="small"
										   type="primary"
										   class="mb10"
										   icon="el-icon-plus"
										   @click="addItem(inx, 'project')"></el-button>
								<el-button size="small"
										   type="danger"
										   icon="el-icon-minus"
										   @click="removeItem(projectInfoForm, inx, 'project')"
										   v-if="inx !== 0"></el-button>
							</div>
						</el-col>
					</el-row>
				</template>

				<!-- 学历 -->
				<template v-if="item.name === 'education'">
					<el-row class="pane-list-container"
							v-for="(educationForm, inx) in educationList"
							:key="'educationList' + inx">
						<el-col :span="4"
								class="upload-container">
							<div class="upload-box">
								<p>学历证书：</p>
								<my-upload :ref="`education0_${inx}`"
										   :isDisabled="isDisabled && !editMode"
										   mode="view"
										   width="200px"
										   height="120px"
										   listType="picture"
										   :maxNum="1"
										   :aid="educationForm.id"
										   tableName="sys_user_edu"
										   :assortment="`edu0_${educationForm.id}`"
										   :acceptType="['PNG', 'JPG', 'JPEG', 'PDF']"></my-upload>
							</div>
							<div class="upload-box">
								<p>学位证书：</p>
								<my-upload :ref="`education1_${inx}`"
										   :isDisabled="isDisabled && !editMode"
										   mode="view"
										   width="200px"
										   height="120px"
										   listType="picture"
										   :maxNum="1"
										   :aid="educationForm.id"
										   tableName="sys_user_edu"
										   :assortment="`edu1_${educationForm.id}`"
										   :acceptType="['PNG', 'JPG', 'JPEG', 'PDF']"></my-upload>
							</div>
						</el-col>
						<el-col :span="20"
								class="flex">
							<div class="pane-list-item">
								<el-form :ref="'educationForm' + inx"
										 :model="educationForm"
										 size="small"
										 :show-message="false"
										 label-width="120px">
									<el-row>
										<el-col :span="12">
											<el-form-item label="证书编号："
														  prop="cerNo">
												<template v-if="editMode">
													<el-input :disabled="isDisabled"
															  v-model="educationForm.cerNo"></el-input>
												</template>
												<template v-else>
													{{ educationForm.cerNo }}
												</template>
											</el-form-item>
										</el-col>
										<el-col :span="12">
											<el-form-item label="学历："
														  prop="education">
												<template v-if="editMode">
													<el-select v-model="educationForm.education"
															   :disabled="isDisabled">
														<el-option v-for="(m, n) in xlList"
																   :key="'学历' + n"
																   :label="m.sname"
																   :value="m.value">
														</el-option>
													</el-select>
												</template>
												<template v-else>
													{{ educationForm.educationName }}
												</template>
											</el-form-item>
										</el-col>
									</el-row>
									<el-row>
										<el-col :span="12">
											<el-form-item label="学历性质："
														  prop="degreeNature">
												<template v-if="editMode">
													<el-select v-model="
                                                            educationForm.degreeNature
                                                        "
															   :disabled="isDisabled">
														<el-option v-for="(m, n) in xlxz"
																   :key="'学历性质' + n"
																   :label="m.sname"
																   :value="m.value">
														</el-option>
													</el-select>
												</template>
												<template v-else>
													{{ educationForm.degreeNatureName }}
												</template>
											</el-form-item>
										</el-col>
										<el-col :span="12">
											<el-form-item label="证书取得日期："
														  prop="issueDate">
												<template v-if="editMode">
													<el-date-picker v-model="educationForm.issueDate"
																	type="date"
																	:disabled="isDisabled"
																	format="yyyy-MM-dd"
																	value-format="yyyy-MM-dd"
																	placeholder="年-月-日">
													</el-date-picker>
												</template>
												<template v-else>
													{{ educationForm.issueDate }}
												</template>
											</el-form-item>
										</el-col>
									</el-row>
									<el-row>
										<el-col :span="12">
											<el-form-item label="毕业院校："
														  prop="academy">
												<template v-if="editMode">
													<el-input :disabled="isDisabled"
															  v-model="educationForm.academy"></el-input>
												</template>
												<template v-else>
													{{ educationForm.academy }}
												</template>
											</el-form-item>
										</el-col>
										<el-col :span="12">
											<el-form-item label="专业："
														  prop="profession">
												<template v-if="editMode">
													<el-input :disabled="isDisabled"
															  v-model="educationForm.profession"></el-input>
												</template>
												<template v-else>
													{{ educationForm.profession }}
												</template>
											</el-form-item>
										</el-col>
									</el-row>
									<el-row>
										<el-col :span="12">
											<el-form-item label="学位名称："
														  prop="degreeName">
												<template v-if="editMode">
													<el-select v-model="educationForm.degreeName"
															   :disabled="isDisabled">
														<el-option v-for="(m, n) in xwlx"
																   :key="'学位类型' + n"
																   :label="m.sname"
																   :value="m.value">
														</el-option>
													</el-select>
												</template>
												<template v-else>
													{{ educationForm.degreeNameChinese }}
												</template>
											</el-form-item>
										</el-col>
										<el-col :span="12">
											<el-form-item label="学位类型："
														  prop="degreeType">
												<template v-if="editMode">
													<el-select v-model="educationForm.degreeType"
															   :disabled="isDisabled">
														<el-option v-for="(m, n) in xwzy"
																   :key="'学位类型' + n"
																   :label="m.sname"
																   :value="m.value">
														</el-option>
													</el-select>
												</template>
												<template v-else>
													{{ educationForm.degreeTypeName }}
												</template>
											</el-form-item>
										</el-col>
									</el-row>
									<el-row>
										<el-col :span="12">
											<el-form-item label="学制 (x 年)："
														  prop="years">
												<template v-if="editMode">
													<el-input :disabled="isDisabled"
															  v-model="educationForm.years">
														<template slot="append">年</template>
													</el-input>
												</template>
												<template v-else>
													{{ educationForm.years + " 年" }}
												</template>
											</el-form-item>
										</el-col>
										<el-col :span="12">
											<el-form-item label="是否全日制："
														  prop="isFull">
												<template v-if="editMode">
													<vxe-switch :disabled="isDisabled"
																v-model="educationForm.isFull"
																open-label="是"
																:open-value="1"
																close-label="否"
																:close-value="0"></vxe-switch>
												</template>
												<template v-else>
													{{
                                                        educationForm.isFull === 1
                                                            ? "是"
                                                            : " 否"
                                                    }}
												</template>
											</el-form-item>
										</el-col>
									</el-row>
								</el-form>
							</div>
							<div class="pane-list-btn"
								 v-if="editMode">
								<el-button size="small"
										   type="primary"
										   class="mb10"
										   icon="el-icon-plus"
										   @click="addItem(inx, 'education')"></el-button>
								<el-button size="small"
										   type="danger"
										   icon="el-icon-minus"
										   @click="removeItem(educationForm, inx, 'education')"
										   v-if="inx !== 0"></el-button>
							</div>
						</el-col>
					</el-row>
				</template>

				<!-- 职称 -->
				<template v-if="item.name === 'career'">
					<el-row class="pane-list-container"
							v-for="(careerForm, inx) in careerList"
							:key="'careerList' + inx">
						<el-col :span="4"
								class="upload-container">
							<div class="upload-box">
								<p>职称证书：</p>
								<my-upload :ref="`career0_${inx}`"
										   :isDisabled="isDisabled && !editMode"
										   mode="view"
										   width="200px"
										   height="120px"
										   listType="picture"
										   :lazyTime="1000"
										   :maxNum="1"
										   :aid="careerForm.id"
										   tableName="sys_user_practice"
										   :assortment="`career0_${careerForm.id}`"
										   :acceptType="['PNG', 'JPG', 'JPEG', 'PDF']"></my-upload>
							</div>
						</el-col>
						<el-col :span="20"
								class="flex">
							<div class="pane-list-item">
								<el-form :ref="'careerForm' + inx"
										 :model="careerForm"
										 size="small"
										 :show-message="false"
										 label-width="120px">
									<el-row>
										<el-col :span="12">
											<el-form-item label="职称证书编号："
														  prop="cerNo">
												<template v-if="editMode">
													<el-input :disabled="isDisabled"
															  v-model="careerForm.cerNo"></el-input>
												</template>
												<template v-else>
													{{ careerForm.cerNo }}
												</template>
											</el-form-item>
										</el-col>
										<el-col :span="12">
											<el-form-item label="职称名称："
														  prop="cerName">
												<template v-if="editMode">
													<el-input :disabled="isDisabled"
															  v-model="careerForm.cerName"></el-input>
												</template>
												<template v-else>
													{{ careerForm.cerName }}
												</template>
											</el-form-item>
										</el-col>
									</el-row>
									<el-row>
										<el-col :span="12">
											<el-form-item label="职称："
														  prop="cerGrade">
												<template v-if="editMode">
													<el-select v-model="careerForm.cerGrade"
															   :disabled="isDisabled">
														<el-option v-for="(m, n) in zc"
																   :key="'职称' + n"
																   :label="m.sname"
																   :value="m.value">
														</el-option>
													</el-select>
												</template>
												<template v-else>
													{{ careerForm.cerGradeName }}
												</template>
											</el-form-item>
										</el-col>
										<el-col :span="12">
											<el-form-item label="职称专业："
														  prop="profession">
												<template v-if="editMode">
													<el-select v-model="careerForm.profession"
															   :disabled="isDisabled">
														<el-option v-for="(m, n) in zczy"
																   :key="'职称专业' + n"
																   :label="m.sname"
																   :value="m.value">
														</el-option>
													</el-select>
												</template>
												<template v-else>
													{{ careerForm.professionName }}
												</template>
											</el-form-item>
										</el-col>
									</el-row>
									<el-row>
										<el-col :span="12">
											<el-form-item label="评审时间："
														  prop="inspectDate">
												<template v-if="editMode">
													<el-date-picker v-model="careerForm.inspectDate"
																	type="date"
																	:disabled="isDisabled"
																	format="yyyy-MM-dd"
																	value-format="yyyy-MM-dd"
																	placeholder="年-月-日">
													</el-date-picker>
												</template>
												<template v-else>
													{{ careerForm.inspectDate }}
												</template>
											</el-form-item>
										</el-col>
										<el-col :span="12">
											<el-form-item label="评审单位："
														  prop="inspectUnit">
												<template v-if="editMode">
													<el-input :disabled="isDisabled"
															  v-model="careerForm.inspectUnit"></el-input>
												</template>
												<template v-else>
													{{ careerForm.inspectUnit }}
												</template>
											</el-form-item>
										</el-col>
									</el-row>
								</el-form>
							</div>
							<div class="pane-list-btn"
								 v-if="editMode">
								<el-button size="small"
										   type="primary"
										   class="mb10"
										   icon="el-icon-plus"
										   @click="addItem(inx, 'career')"></el-button>
								<el-button size="small"
										   type="danger"
										   icon="el-icon-minus"
										   @click="removeItem(careerForm, inx, 'career')"
										   v-if="inx !== 0"></el-button>
							</div>
						</el-col>
					</el-row>
				</template>

				<!-- 执业资格 -->
				<template v-if="item.name === 'profession'">
					<el-row class="pane-list-container"
							v-for="(qualiForm, inx) in qualiList"
							:key="'qualiList' + inx">
						<el-col :span="4"
								class="upload-container">
							<div class="upload-box">
								<p>执业资格证书：</p>
								<my-upload :ref="`profession0_${inx}`"
										   :isDisabled="isDisabled && !editMode"
										   mode="view"
										   :lazyTime="2000"
										   width="200px"
										   height="120px"
										   listType="picture"
										   :maxNum="1"
										   :aid="qualiForm.id"
										   tableName="sys_user_cer"
										   :assortment="`qualification0_${qualiForm.id}`"
										   :acceptType="['PNG', 'JPG', 'JPEG', 'PDF']"></my-upload>
							</div>
						</el-col>
						<el-col :span="20"
								class="flex">
							<div class="pane-list-item">
								<el-form :ref="'qualiForm' + inx"
										 :model="qualiForm"
										 size="small"
										 :show-message="false"
										 label-width="120px">
									<el-row>
										<el-col :span="12">
											<el-form-item label="证书编号："
														  prop="cerNo">
												<template v-if="editMode">
													<el-input :disabled="isDisabled"
															  v-model="qualiForm.cerNo"></el-input>
												</template>
												<template v-else>
													{{ qualiForm.cerNo }}
												</template>
											</el-form-item>
										</el-col>
										<el-col :span="12">
											<el-form-item label="证书名称："
														  prop="sname">
												<template v-if="editMode">
													<el-input :disabled="isDisabled"
															  v-model="qualiForm.sname"></el-input>
												</template>
												<template v-else>
													{{ qualiForm.sname }}
												</template>
											</el-form-item>
										</el-col>
									</el-row>
									<el-row>
										<el-col :span="12">
											<el-form-item label="执业资格："
														  prop="type">
												<template v-if="editMode">
													<el-select v-model="qualiForm.type"
															   @change="
                                                            onChangeType(
                                                                $event,
                                                                qualiForm
                                                            )
                                                        "
															   :disabled="isDisabled">
														<el-option v-for="(m, n) in zyzg"
																   :key="'执业资格' + n"
																   :label="m.sname"
																   :value="m.value">
														</el-option>
													</el-select>
												</template>
												<template v-else>
													{{ qualiForm.typeName }}
												</template>
											</el-form-item>
										</el-col>
										<el-col :span="12">
											<el-form-item label="登记专业："
														  prop="professionArr">
												<template v-if="editMode">
													<el-select v-model="qualiForm.professionArr"
															   :disabled="isDisabled"
															   multiple>
														<el-option v-for="(
                                                                m, n
                                                            ) in qualiForm.professionList"
																   :key="'登记专业' + n"
																   :label="m.sname"
																   :value="m.value">
														</el-option>
													</el-select>
												</template>
												<template v-else>
													{{ qualiForm.professionName }}
												</template>
											</el-form-item>
										</el-col>
									</el-row>
									<el-row>
										<el-col :span="12">
											<el-form-item label="证书等级："
														  prop="grade">
												<template v-if="editMode">
													<el-select v-model="qualiForm.grade"
															   :disabled="isDisabled">
														<el-option v-for="(m, n) in zsdj"
																   :key="'证书等级' + n"
																   :label="m.sname"
																   :value="m.value">
														</el-option>
													</el-select>
												</template>
												<template v-else>
													{{ qualiForm.gradeName }}
												</template>
											</el-form-item>
										</el-col>
										<el-col :span="12">
											<el-form-item label="发证单位："
														  prop="issueUnit">
												<template v-if="editMode">
													<el-input :disabled="isDisabled"
															  v-model="qualiForm.issueUnit"></el-input>
												</template>
												<template v-else>
													{{ qualiForm.issueUnit }}
												</template>
											</el-form-item>
										</el-col>
									</el-row>
									<el-row>
										<el-col :span="12">
											<el-form-item label="评审时间："
														  prop="issueDate">
												<template v-if="editMode">
													<el-input :disabled="isDisabled"
															  v-model="qualiForm.issueDate"></el-input>
												</template>
												<template v-else>
													{{ qualiForm.issueDate }}
												</template>
											</el-form-item>
										</el-col>
									</el-row>
								</el-form>
							</div>
							<div class="pane-list-btn"
								 v-if="editMode">
								<el-button size="small"
										   type="primary"
										   class="mb10"
										   icon="el-icon-plus"
										   @click="addItem(inx, 'profession')"></el-button>
								<el-button size="small"
										   type="danger"
										   icon="el-icon-minus"
										   @click="removeItem(qualiForm, inx, 'profession')"
										   v-if="inx !== 0"></el-button>
							</div>
						</el-col>
					</el-row>
				</template>

				<!-- 其它 -->
				<template v-if="item.name === 'other'">
					<el-row class="pane-list-container"
							v-for="(otherForm, inx) in otherList"
							:key="'otherList' + inx">
						<el-col :span="4"
								class="upload-container">
							<div class="upload-box">
								<p>其它证书：</p>
								<my-upload :ref="`other0_${inx}`"
										   :isDisabled="isDisabled && !editMode"
										   mode="view"
										   :lazyTime="3000"
										   width="200px"
										   height="120px"
										   listType="picture"
										   :maxNum="1"
										   :aid="otherForm.id"
										   tableName="sys_user_other_cer"
										   :assortment="`other0_${otherForm.id}`"
										   :acceptType="['PNG', 'JPG', 'JPEG', 'PDF']"></my-upload>
							</div>
						</el-col>
						<el-col :span="20"
								class="flex">
							<div class="pane-list-item">
								<el-form :ref="'otherForm' + inx"
										 :model="otherForm"
										 size="small"
										 :show-message="false"
										 label-width="120px">
									<el-row>
										<el-col :span="12">
											<el-form-item label="证书编号："
														  prop="cerNo">
												<template v-if="editMode">
													<el-input :disabled="isDisabled"
															  v-model="otherForm.cerNo"></el-input>
												</template>
												<template v-else>
													{{ otherForm.cerNo }}
												</template>
											</el-form-item>
										</el-col>
										<el-col :span="12">
											<el-form-item label="证书名称："
														  prop="cerName">
												<template v-if="editMode">
													<el-input :disabled="isDisabled"
															  v-model="otherForm.cerName"></el-input>
												</template>
												<template v-else>
													{{ otherForm.cerName }}
												</template>
											</el-form-item>
										</el-col>
									</el-row>
									<el-row>
										<el-col :span="12">
											<el-form-item label="证书类型："
														  prop="cerType">
												<template v-if="editMode">
													<el-input :disabled="isDisabled"
															  v-model="otherForm.cerType"></el-input>
												</template>
												<template v-else>
													{{ otherForm.cerType }}
												</template>
											</el-form-item>
										</el-col>
										<el-col :span="12">
											<el-form-item label="发证单位："
														  prop="issueUnit">
												<template v-if="editMode">
													<el-input :disabled="isDisabled"
															  v-model="otherForm.issueUnit"></el-input>
												</template>
												<template v-else>
													{{ otherForm.issueUnit }}
												</template>
											</el-form-item>
										</el-col>
									</el-row>
									<el-row>
										<el-col :span="12">
											<el-form-item label="发证日期："
														  prop="issueDate">
												<template v-if="editMode">
													<el-date-picker v-model="otherForm.issueDate"
																	type="date"
																	:disabled="isDisabled"
																	format="yyyy-MM-dd"
																	value-format="yyyy-MM-dd"
																	placeholder="年-月-日">
													</el-date-picker>
												</template>
												<template v-else>
													{{ otherForm.issueDate }}
												</template>
											</el-form-item>
										</el-col>
										<el-col :span="12">
											<el-form-item label="有效期至："
														  prop="dueDate">
												<template v-if="editMode">
													<el-date-picker v-model="otherForm.dueDate"
																	type="date"
																	:disabled="isDisabled"
																	format="yyyy-MM-dd"
																	value-format="yyyy-MM-dd"
																	placeholder="年-月-日">
													</el-date-picker>
												</template>
												<template v-else>
													{{ otherForm.dueDate }}
												</template>
											</el-form-item>
										</el-col>
									</el-row>
								</el-form>
							</div>
							<div class="pane-list-btn"
								 v-if="editMode">
								<el-button size="small"
										   type="primary"
										   class="mb10"
										   icon="el-icon-plus"
										   @click="addItem(inx, 'other')"></el-button>
								<el-button size="small"
										   type="danger"
										   icon="el-icon-minus"
										   @click="removeItem(otherForm, inx, 'other')"
										   v-if="inx !== 0"></el-button>
							</div>
						</el-col>
					</el-row>
				</template>
			</el-collapse-item>
		</el-collapse>
	</div>
</template>

<script>
// js
import { mapState } from 'vuex'
import { getInfoById } from 'utils/tools'

// api
import { selectRoleTree } from 'api/system/role.js'
import {
	saveOrUpdatePlatformUser,
	getOneInfo,
	checkUserInfo,
} from 'api/system/user.js'
import { deleteFile } from 'api/upload/upload'
export default {
	name: '',
	props: {
		// 当前人员（简单信息）
		curUser: {
			type: Object,
			default: () => {
				return {}
			},
		},

		// 当前模式 （查看 或者 新增，编辑）
		curMode: {
			type: String,
			default: 'add',
		},
	},
	data() {
		return {
			activeNames: [
				'baseInfo',
				'companyInfo',
				'projectInfo',
				'education',
				'career',
				'profession',
				'other',
			],
			infoList: [
				{
					title: '基本信息',
					name: 'baseInfo',
				},
				{
					title: '工作经验',
					name: 'companyInfo',
				},
				{
					title: '项目经验',
					name: 'projectInfo',
				},
				{
					title: '学历',
					name: 'education',
				},
				{
					title: '职称',
					name: 'career',
				},
				{
					title: '执业资格',
					name: 'profession',
				},
				{
					title: '其他证书',
					name: 'other',
				},
			],
			currentUser: {},
			roleTreeData: [], // 角色
			disRoles: [], // 不可编辑的角色
			selectArr: [],
			// 基本信息
			baseForm: {
				sname: '',
				username: '',
				phone: '',
				idCard: '',
				sex: '',
				nation: '',
				birthDate: '',
				age: '',
				orEnable: 1,
			},
			baseRules: {
				sname: [{ required: true, message: '请输入姓名' }],
				username: [{ required: true, message: '请输入用户名' }],
				phone: [
					{ required: true, message: '请输入手机号' },
					{
						pattern: /^1[3-9][0-9]{9}$/,
						message: '手机号码格式不正确，请重新输入',
					},
				],
				idCard: [
					{
						pattern:
							/^[1-9][0-9]{5}(18|19|(2[0-9]))[0-9]{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)[0-9]{3}[0-9Xx]$/,
						message: '身份证输入有误',
					},
				],
			},
			// 工作经验
			companyInfoList: [
				{
					startDate: '', // 开始日期
					endDate: '', // 结束日期
					dateRange: [], // 日期范围
					company: '', // 公司名称
					typeName: '', // 公司性质
					functions: '', // 职能
					industry: '', // 行业
					postion: '', // 职位
					post: '', // 岗位
					description: '', // 工作描述
					jobType: 1, // 工作类型
				},
			],
			// 项目经验
			projectInfoList: [
				{
					company: '', // 所属公司
					startTime: '', // 开始日期
					endTime: '', // 结束日期
					proName: '', // 项目名称
					proDes: '', // 项目描述
					dutyDes: '', // 责任描述
				},
			],
			// 学历
			educationList: [
				{
					cerNo: '', // 证书编号
					education: '', // 学历
					degreeNature: '', // 学历性质
					issueDate: '', // 证书取得日期
					academy: '', // 毕业院校
					profession: '', // 专业
					degreeName: '', // 学位名称
					degreeType: '', // 学位类型
					years: '', // 学制（x 年）
					isFull: 1, // 0否 1是 （是否全日制）
				},
			],
			delEducation: [],
			// 职称
			careerList: [
				{
					cerNo: '', // 证书编号
					cerName: '', // 职称证书名称
					cerGrade: '', // 职称（码表）
					profession: '', // 职称专业（多选码表）
					inspectDate: '', // 评审时间
					inspectUnit: '', // 评审单位
				},
			],
			delCareer: [],
			// 执业资格
			qualiList: [
				{
					cerNo: '', // 证书编号
					sname: '', // 执业资格证书名称
					type: '', // 执业资格（码表）
					profession: '', // 登记专业（多选码表）
					professionArr: [], // 登记专业绑定数组
					professionList: [], // 登记专业数据数组
					grade: '', // 证书等级(码表)
					issueUnit: '', // 发证单位
					issueDate: '', // 发证日期
				},
			],
			delQuali: [],
			// 其它
			otherList: [
				{
					cerNo: '', // 证书编号
					cerName: '', // 证书名称
					cerType: '', // 证书类型
					issueUnit: '', // 发证单位
					issueDate: '', // 发证日期
					dueDate: '', // 有效截止日期
				},
			],
			delOther: [],
		}
	},
	created() {
		this.currentUser = this.$utils.clone(this.curUser, true)

		// 获取角色树
		this.getRoleData()

		if (this.currentUser?.id) {
			this.getAllInfo()
		}

		// 非查看模式 只显示基本信息
		if (this.curMode !== 'view') {
			this.infoList = this.infoList.slice(0, 1)
		}
	},
	methods: {
		// 获取全部信息
		getAllInfo() {
			getOneInfo({ id: this.currentUser.id })
				.then((res) => {
					// 基础信息
					this.baseForm = res.data.sysUser

					// 工作经验
					this.companyInfoList = this.$utils.clone(
						res.data.sysUserWorkExps,
						true
					)
					this.companyInfoList.map((x) => {
						x.dateRange = []
						x.startDate ? x.dateRange.push(x.startDate) : ''
						x.endDate ? x.dateRange.push(x.endDate) : ''
					})

					// 项目经验
					this.projectInfoList = this.$utils.clone(
						res.data.sysUserProExps,
						true
					)
					this.projectInfoList.map((x) => {
						x.dateRange = []
						x.startTime ? x.dateRange.push(x.startTime) : ''
						x.endTime ? x.dateRange.push(x.endTime) : ''
					})

					// 学历
					this.educationList = res.data.sysUserEdu

					// 职称
					this.careerList = res.data.sysUserPractice

					// 执业资格证书
					res.data.sysUserCer.map((x) => {
						x.professionArr =
							x.profession === '' ? [] : x.profession.split(',')
						this.onChangeType(x.type, x)
					})
					this.qualiList = res.data.sysUserCer

					// 其它
					this.otherList = res.data.sysUserOtherCer
				})
				.catch((err) => {})
		},

		// 获取角色数据
		getRoleData() {
			let params = {
				userId: this.currentUser.id,
			}
			selectRoleTree(params).then((res) => {
				this.roleTreeData = res.data
				this.disRoles = res.data.filter((x) => x.disabled)
			})
		},

		// 基础信息 -- 角色 ---标签移除
		onRemoveTag(val) {
			let _dis_exist = this.disRoles.find((x) => x.id === val)
			if (_dis_exist) {
				this.baseForm.roleIds = JSON.parse(
					JSON.stringify(this.selectArr)
				)
			}
		},

		// 执业资格切换 赋值 登记专业
		onChangeType(val, obj) {
			// console.log(val)
			let _item = this.zyzg.find((x) => x.value === val)
			obj.professionList = _item ? _item.children : []
		},

		// 清空一些保存的
		doClear() {
			this.delEducation = []
			this.delCareer = []
			this.delQuali = []
			this.delOther = []
		},

		// 添加元素
		addItem(index) {
			let item = {}
			switch (this.activeTab) {
				// 工作经验
				case 'work':
					item = {
						startDate: '', // 开始日期
						endDate: '', // 结束日期
						dateRange: [], // 日期范围
						company: '', // 公司名称
						typeName: '', // 公司性质
						functions: '', // 职能
						industry: '', // 行业
						postion: '', // 职位
						post: '', // 岗位
						description: '', // 工作描述
						jobType: 1, // 工作类型
					}
					// this.workList.splice(index+1, 0, item);
					this.companyInfoList.push(item)
					break
				// 项目经验
				case 'project':
					item = {
						company: '', // 所属公司
						dateRange: [], // 日期范围
						startTime: '', // 开始日期
						endTime: '', // 结束日期
						proName: '', // 项目名称
						proDes: '', // 项目描述
						dutyDes: '', // 责任描述
					}
					// this.projectList.splice(index+1, 0, item);
					this.projectInfoList.push(item)
					break
				// 学历
				case 'education':
					item = {
						cerNo: '', // 证书编号
						education: '', // 学历
						degreeNature: '', // 学历性质
						issueDate: '', // 证书取得日期
						academy: '', // 毕业院校
						profession: '', // 专业
						degreeName: '', // 学位名称
						degreeType: '', // 学位类型
						years: '', // 学制（x 年）
						isFull: 1, // 0否 1是 （是否全日制）
					}
					// this.educationList.splice(index+1, 0, item);
					this.educationList.push(item)
					break
				// 职称
				case 'career':
					item = {
						id: '',
						cerNo: '', // 证书编号
						cerName: '', // 职称证书名称
						cerGrade: '', // 职称（码表）
						profession: '', // 职称专业（多选码表）
						inspectDate: '', // 评审时间
						inspectUnit: '', // 评审单位
					}
					// this.careerList.splice(index+1, 0, item);
					this.careerList.push(item)
					break
				// 执业资格
				case 'qualification':
					;(item = {
						cerNo: '', // 证书编号
						sname: '', // 执业资格证书名称
						type: '', // 执业资格（码表）
						profession: '', // 登记专业（多选码表）
						professionArr: [], // 登记专业绑定数组
						professionList: [], // 登记专业数据数组
						grade: '', // 证书等级(码表)
						issueUnit: '', // 发证单位
						issueDate: '', // 发证日期
					}),
						// this.qualiList.splice(index+1, 0, item);
						this.qualiList.push(item)
					break
				// 其他证书
				case 'other':
					item = {
						cerNo: '', // 证书编号
						cerName: '', // 证书名称
						cerType: '', // 证书类型
						issueUnit: '', // 发证单位
						issueDate: '', // 发证日期
						dueDate: '', // 有效截止日期
					}
					// this.otherList.splice(index+1, 0, item);
					this.otherList.push(item)
					break
			}
		},

		// 移除元素
		removeItem(item, index, name) {
			switch (name) {
				case 'work':
					this.companyInfoList.splice(index, 1)
					break
				case 'project':
					this.projectInfoList.splice(index, 1)
					break
				// 学历
				case 'education':
					// id 不存在， 直接删除
					if (item.id) {
						// 获取附件id
						this.getFileId(index)
						this.delEducation.push(item)
					}
					this.educationList.splice(index, 1)
					break
				// 职称
				case 'career':
					// id 不存在， 直接删除
					if (item.id) {
						// 获取附件id
						this.getFileId(index)
						this.delCareer.push(item)
					}
					this.careerList.splice(index, 1)
					break
				// 执业资格
				case 'qualification':
					// id 不存在， 直接删除
					if (item.id) {
						// 获取附件id
						this.getFileId(index)
						this.delQuali.push(item)
					}
					this.qualiList.splice(index, 1)
					break
				// 其他证书
				case 'other':
					// id 不存在， 直接删除
					if (item.id) {
						// 获取附件id
						this.getFileId(index)
						this.delOther.push(item)
					}
					this.otherList.splice(index, 1)
					break
			}
		},

		// 保存附件
		saveFile(resArr) {
			resArr.map((item, index) => {
				// 学历证书
				let name1 = `${this.activeTab}0_${index}`
				this.$refs[name1] ? this.$refs[name1][0].fileSend(item.id) : ''

				// 学位证书
				let name2 = `${this.activeTab}1_${index}`
				this.$refs[name2] ? this.$refs[name2][0].fileSend(item.id) : ''
			})
		},

		// 获取附件id
		getFileId(index) {
			// 学历证书
			let name1 = `${this.activeTab}0_${index}`
			let _id1 =
				this.$refs[name1] && this.$refs[name1][0].fileList[0]
					? this.$refs[name1][0].fileList[0].id
					: ''
			_id1 ? this.delFile.push(_id1) : ''

			// 学位证书
			let name2 = `${this.activeTab}1_${index}`
			let _id2 =
				this.$refs[name2] && this.$refs[name2][0].fileList[0]
					? this.$refs[name2][0].fileList[0].id
					: ''
			_id2 ? this.delFile.push(_id2) : ''
		},

		// 删除附件
		deleteFile() {
			let arr = JSON.parse(JSON.stringify(this.delFile))
			arr.map((x) => {
				deleteFile({ id: x })
					.then((res) => {})
					.catch((err) => {})
			})
		},

		// 取消按钮 loading 状态
		resetBtnLoading() {
			setTimeout(() => {
				this.btnLoading = false
			}, 2000)
		},

		// 执行保存
		doSave() {
			let params = this.$utils.clone(this.baseForm, true)
			let that = this
			return new Promise((resolve, reject) => {
				that.$refs.baseForm[0].validate((valid) => {
					if (valid) {
						checkUserInfo({
							username: params.username.trim(),
							phone: params.phone,
							id: params.id,
						}).then((res) => {
							let { phoneSign, usernameSign } = res.data
							if (phoneSign === 1) {
								this.$message.warning('该手机号已绑定用户。')
								resolve(false)
								return
							}
							if (Object.keys(usernameSign).length > 0) {
								let str = `用户名已存在，将无法保存成功。系统为您提供新的用户名，如需更改请重新输入。`
								this.$message.warning(str)
								this.baseForm.username = usernameSign.userName
								resolve(false)
								return
							}
							resolve(true)
						})
					} else {
						this.$message.warning('请完善必填项!')
						resolve(false)
					}
				})
			})
		},

		//
		handleChange() {},
	},
	computed: {
		...mapState('user', {
			userInfo: (state) => state.userInfo,
		}),

		...mapState('dict', {
			mz: (state) => state.projectDict.mz,
			dwxz: (state) => state.projectDict.dwxz,
			xlList: (state) => state.projectDict.zgxl,
			xlxz: (state) => state.projectDict.xlxz,
			xwlx: (state) => state.projectDict.zgxw,
			xwzy: (state) => state.projectDict.xwzy,
			zc: (state) => state.projectDict.zc,
			zczy: (state) => state.projectDict.zczy,
			zyzg: (state) => state.projectDict.zyzg,
			zsdj: (state) => state.projectDict.zsdj,
		}),

		// 是否不能编辑
		isDisabled() {
			// return false;
			return true
		},

		// 其他资料是否可编辑
		editMode() {
			// return this.curMode !== 'view';
			return false
		},
	},
	watch: {
		// 监听身份证的输入，计算出生日期 和 年龄
		'baseForm.idCard': {
			handler: function (val) {
				// console.log(this)
				let dateInfo = val && val !== '' ? getInfoById(val) : ''
				if (dateInfo.age) {
					this.baseForm.age = dateInfo.age
					this.baseForm.birthDate = dateInfo.birthDate
					this.baseForm.sex = dateInfo.sex
				} else {
					this.baseForm.age = ''
					this.baseForm.birthDate = ''
					this.baseForm.sex = ''
				}
			},
			deep: true,
		},

		// 监听 角色
		'baseForm.roleIds': {
			handler: function (arr) {
				this.selectArr = JSON.parse(JSON.stringify(arr))
			},
			deep: true,
		},
	},
}
</script>

<style lang="less" scoped>
.wrap-container {
	max-height: 600px;
	overflow-y: auto;
}

.pane-list-container {
	display: flex;
	position: relative;
	margin-bottom: 20px;
	border: 2px solid #f7f7f7;
	padding-top: 15px;

	@btnWidth: 80px;

	// &:hover {
	//     box-shadow: 0px 1px 6px 1px #dddfe2;
	// }

	.pane-list-item {
		flex: 1;
		width: calc(~'100% - @{btnWidth}');
		padding-right: 10px;
	}

	.pane-list-btn {
		width: @btnWidth;
		text-align: right;
		padding-right: 15px;
	}
}

.upload-container {
	width: 260px;
	padding: 0 30px;
	flex: 1;

	.upload-box {
		margin-bottom: 10px;

		&:last-child {
			margin-bottom: 20px;
		}
	}

	p {
		color: #606266;
		font-weight: normal;
		font-size: 14px;
		line-height: 32px;
	}
}
</style>
<style lang="less">
.collapse-layout {
	.el-collapse-item__header {
		background-color: #eff6fe;
		padding: 0 10px;
		margin-bottom: 10px;
	}

	.el-collapse-item__content {
		padding: 0 10px 25px 10px;
	}
}
</style>
